import React from 'react';

// Strict Effect에도 한번만 실행됨을 보장하기 위한 effect
export function useEffectOnce(effect: React.EffectCallback) {
  const isRun = React.useRef(false);

  React.useEffect(() => {
    if (!isRun.current) {
      isRun.current = true;
      effect();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
}

export function useMounted() {
  const [mounted, setMounted] = React.useState(false);

  React.useEffect(() => {
    setMounted(true);
  }, []);

  return mounted;
}
